import React from 'react';

import Text from 'components/Text/Text';

import * as S from './PullStats.styles';

export interface PullStatsProps {
  pullStats: Array<{
    id: string;
    title: string;
    subtitle: string;
  }>;
}

const defaultProps: Partial<PullStatsProps> = {};

const PullStats: React.FunctionComponent<PullStatsProps> = ({ pullStats }) => {
  return (
    <S.PullStatsWrapper>
      {pullStats.map(({ title, id, subtitle }) => (
        <div key={id}>
          <Text text={title} size="display" />
          <Text text={subtitle} size="small" />
        </div>
      ))}
    </S.PullStatsWrapper>
  );
};

PullStats.defaultProps = defaultProps;

export default PullStats;
